import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  RecalculatePremiumClientRequest,
  RecalculatePremiumClientResponse,
} from '../../../@types/RecalculatePremium'
import { api } from '../../../Services/API'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useRecalculatePremiumStore } from '../../../Stores/useRecalculatePremiumStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: RecalculatePremiumClientRequest) => {
  const response = await api.post<RecalculatePremiumClientResponse>(
    API_ROUTES.recalculatePremium,
    payload,
  )

  return response.data
}

export const useRecalculatePremium = () => {
  const { setRecalculatePremium } = useRecalculatePremiumStore()
  const { runPetisSimulation, setRunPetisSimulation, setPacksCampaigns } =
    useRunPetisSimulationStore()
  const { setQuoteId } = useSimulatorStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: RecalculatePremiumClientRequest) => request(payload),
    onSuccess(data) {
      setRecalculatePremium(data)

      const newRunPetisSimulationFromRecalculate: any = {
        ...runPetisSimulation,
        discountsCampaigns: data.discountsCampaigns || [],
        runPetisSimulationResponse: {
          ...runPetisSimulation?.runPetisSimulationResponse,
          insuredObjectGroup:
            data?.runPetisSimulationResponse?.insuredObjectGroup,
          quoteId: data?.runPetisSimulationResponse?.quoteId || '',
          referrals: data?.runPetisSimulationResponse?.referrals || [],
        },
      }

      setQuoteId(data?.runPetisSimulationResponse?.quoteId || '')
      setRunPetisSimulation(newRunPetisSimulationFromRecalculate)
      setPacksCampaigns(data.discountsCampaigns || [])
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
